export const emailPattern = /^[^\s@]{1,64}@[^\s@]{1,255}\.[^\s@]{2,16}$/
export const last4DigitSsnPattern = /^[/\d]{4}$/
export const routingNumberPattern = /^[/\d]{9}$/
export const accountNumberPattern = /^[A-Za-z0-9\s\-:/]+$/
export const nickNamePattern = /^[A-Za-z0-9\s\-:/()[\]|]*$/
export const UserTypedEmailKey = 'TypedEmail'
export const BrowserSessionKey = 'BrowserSessionKey'
export const MsalCurrentStateSessionKey = 'rcm.msal.state'

//Api End points
